export default "__VITE_ASSET__f80c1713__"